// extracted by mini-css-extract-plugin
module.exports = {"specialists":"mPElg","specialists_header":"_2kUzg","specialists_table":"_1ObX4","no-data":"Q9LDY","specialists_table_total":"_3d-mJ"};